var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-screen"}},[_c('map-section'),_c('div',{staticClass:"container hungarospa-container"},[_c('transition',{attrs:{"mode":"in-out"}},[(_vm.isFacilitySectionVisible)?_c('facilities-section'):_vm._e()],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }